import { TFileTypes } from '@interfaces/import/import';

import { EFileExtensions, EMIMETypes } from '@enums/common';
import { EDropzoneFileErrorCodes } from '@enums/dropzone';

export const acceptedFileTypes: TFileTypes = {
	[EMIMETypes.zip]: [EFileExtensions.zip],
	[EMIMETypes.xml]: [EFileExtensions.xml],
};

export const MAX_FILES = 30;

export const fileErrors = {
	[EDropzoneFileErrorCodes.fileInvalidType]: 'Extension is not supported. Supports: ZIP, XML.',
	[EDropzoneFileErrorCodes.tooManyFiles]: `Too many files. Max ${MAX_FILES} files.`,
};

export const supportsText = 'Supports: ZIP, XML';

export const additionalText = `
	File name must start with the CF type, CF version, node id and timestamp at the end. Examples:
	CUCP_VENDOR_5.2.51.18_1_1_20240125131848.xml
	CUUP_3GPP_5.2.51.18_1_1_20240125131848.xml
	DU_VENDOR_5.2.51.18_1_1_20240125131848.xml
	CUUP_VENDOR_5.2.51.18_1_1_20240125131848.xml
`;
